/** Caps timeline events in the business-case context slice that can carry message body excerpts. */
export const ASSISTANT_BUSINESS_CASE_EXCERPT_MAX_EVENTS = 8;
